// Mock data for Nikki's Next Level luxury hair & beauty store
// NOTE: This data is mocked for the frontend-only phase and will be
// replaced with real backend data during integration.
import braidsImg from './assets/braids.jpg';
import wigStraightImg from './assets/wig_straight.png';
import wigBodywaveImg from './assets/wig_bodywave.png';
import wigStraight1 from './assets/wig_straight_1.webp';
import wigStraight2 from './assets/wig_straight_2.webp';
import wigStraight3 from './assets/wig_straight_3.webp';
import wigBodywave1 from './assets/wig_bodywave_1.webp';
import wigBodywave2 from './assets/wig_bodywave_2.webp';
import bundleRawImg from './assets/bundle_raw.webp';
import frontalImg from './assets/frontal_sizes.webp';
import bundlesCollectionImg from './assets/bundles_collection.webp';
import silkDynastyProduct from './assets/silk_dynasty_product.png';
import braidXpr1 from './assets/braid_xpr1.png';
import braidXpr2 from './assets/braid_xpr2.png';
import braid6xMain from './assets/braid_6x_main.png';
import xpr4a from './assets/xpr4_a.png';
import xpr4b from './assets/xpr4_b.png';
import xpr4c from './assets/xpr4_c.png';
import xpr4d from './assets/xpr4_d.png';
import xpr6pack from './assets/xpr_6xpack.jpeg';
import xprLight from './assets/xpr_lightweight.jpeg';
import xprBanner from './assets/xpr_banner.jpeg';
import xprPink from './assets/xpr_pink.jpeg';
import tlook1 from './assets/look1.webp';
import tlook2 from './assets/look2.webp';
import tlook3 from './assets/look3.webp';
import tlook4 from './assets/look4.webp';
import tlook6 from './assets/look6.webp';
import tlook7 from './assets/look7.webp';
import tbraid1 from './assets/braid1.webp';
import tbraid3 from './assets/braid3.jpeg';
import tbraid5 from './assets/braid5.webp';

export const BRAIDS_IMG = braidsImg;

export const CONTACT = {
  phonePrimary: '1 (888) 989-1908',
  phoneSecondary: '1 (513) 901-1908',
  email: 'brooke.knight@nikkisnextlevel.com',
  address: 'Cincinnati, Ohio',
};

export const SOCIALS = [
  { name: 'LinkedIn', url: 'https://www.linkedin.com/in/brooke-knight-15532442b/', icon: 'linkedin' },
  { name: 'Instagram', url: 'https://www.instagram.com/nikkinextlevel?igsh=N2cyY3Fjc2U4cXEw', icon: 'instagram' },
  { name: 'Facebook', url: 'https://www.facebook.com/share/1Li3wv4zP2/?mibextid=wwXIfr', icon: 'facebook' },
  { name: 'Pinterest', url: 'https://pin.it/38NUKbMJx', icon: 'pinterest' },
  { name: 'TikTok', url: 'https://www.tiktok.com/@nikkis.next.level?_r=1&_t=ZP-96w9kLuE96N', icon: 'tiktok' },
  { name: 'YouTube', url: 'https://www.youtube.com/@NikkisNextLevel', icon: 'youtube' },
];

// Hero collage \u2014 five different skin tones & hairstyles
export const HERO_COLLAGE = [
  { src: 'https://images.unsplash.com/photo-1560264641-1b5191cc63e2', label: 'Body Wave' },
  { src: 'https://images.unsplash.com/photo-1747979022469-43e0f3d7641f', label: 'Straight' },
  { src: 'https://images.unsplash.com/photo-1614173968962-0e61c5ed196f', label: 'Braids' },
  { src: 'https://images.unsplash.com/photo-1554519934-e32b1629d9ee', label: 'Long Curly' },
  { src: 'https://images.unsplash.com/photo-1616166183781-0fdd2ef83374', label: 'Knotless Braids' },
];

export const CATEGORIES = [
  {
    slug: 'wigs',
    name: 'Wigs',
    tagline: 'Glueless luxury units, ready to wear',
    image: wigStraightImg,
  },
  {
    slug: 'bundles',
    name: 'Luxury Bundles',
    tagline: 'Virgin hair, premium quality, sew-in ready',
    image: bundlesCollectionImg,
  },
  {
    slug: 'braiding-hair',
    name: 'Braiding Hair',
    tagline: 'Pre-stretched, itch-free & feather light',
    image: braidsImg,
  },
  {
    slug: 'frontals',
    name: 'Frontals',
    tagline: 'HD lace frontals & closures',
    image: 'https://static.prod-images.emergentagent.com/jobs/21a05e27-1cb3-4e9b-9a17-4bf2532d5b1a/images/8a90d99e90abaa3ce4ff169c0a49d889cae4a15526632edea5c04ff60613b8b8.jpeg',
  },
  {
    slug: 'accessories',
    name: 'Accessories',
    tagline: 'Bonnets, edge control & finishing tools',
    image: 'https://images.unsplash.com/photo-1744177762258-c98418b7a4eb',
  },
];

// Imperial Luxe Collection description — used as each product's description
export const IMPERIAL_LUXE_DESC =
  "Experience the beauty of true luxury with the Imperial Luxe Collection from Nikki's Next Level Hair & Beauty. Crafted from premium-quality human hair, Imperial Luxe is designed for women who demand sophistication, versatility, and flawless results. Featuring a silky-soft texture, natural movement, and exceptional durability, Imperial Luxe delivers a polished, salon-quality look that blends seamlessly while maintaining its luxurious appearance wear after wear. Whether you prefer sleek straight styles, glamorous body waves, or soft flowing curls, Imperial Luxe provides the perfect foundation for effortless beauty and confidence. Imperial Luxe is more than hair — it's a statement of confidence, beauty, and timeless elegance.";

const IMPERIAL_LUXE_FEATURES = [
  'Premium-Quality Human Hair',
  'Soft, Silky Texture',
  'Minimal Shedding & Tangle Resistance',
  'Long-Lasting Durability',
  'Natural Shine & Movement',
  'Heat Styling Friendly',
  'Available in Lengths 8"–30"',
  'Super Drawn — Full Thickness Root to Tip',
];

const IMPERIAL_LUXE_DATA = [
  { id: 'il-straight', texture: 'Straight', image: 'https://static.prod-images.emergentagent.com/jobs/21a05e27-1cb3-4e9b-9a17-4bf2532d5b1a/images/f64837643ba02bef0db33c22f38c920f44173acde9a3daea564ba70fa02189e9.jpeg', rating: 4.9, reviews: 86 },
  { id: 'il-body-wave', texture: 'Body Wave', image: 'https://static.prod-images.emergentagent.com/jobs/21a05e27-1cb3-4e9b-9a17-4bf2532d5b1a/images/6b737d6084321b7ce50dc6dc834861c9d51ffb2a6bde15befb2076a9ced01a27.jpeg', rating: 4.9, reviews: 72 },
  { id: 'il-loose-deep', texture: 'Loose Deep', image: 'https://static.prod-images.emergentagent.com/jobs/21a05e27-1cb3-4e9b-9a17-4bf2532d5b1a/images/bd5454bbe0943f569096bb709f4e51acc4aa117216bfffba2d53b809766a05f2.jpeg', rating: 4.8, reviews: 54 },
  { id: 'il-deep-wave', texture: 'Deep Wave', image: 'https://static.prod-images.emergentagent.com/jobs/21a05e27-1cb3-4e9b-9a17-4bf2532d5b1a/images/3ef44abd0e6a8ce6da5d74a4b47d8064bff81dc4afc40b3d34f7039b1d173d46.jpeg', rating: 4.9, reviews: 61 },
  { id: 'il-water-wave', texture: 'Water Wave', image: 'https://static.prod-images.emergentagent.com/jobs/21a05e27-1cb3-4e9b-9a17-4bf2532d5b1a/images/00e664981b7db96177afe5b112bb4480449e7f76ee466f4f5aa2c2ef950e74d1.jpeg', rating: 4.8, reviews: 47 },
  { id: 'il-loose-wave', texture: 'Loose Wave', image: 'https://static.prod-images.emergentagent.com/jobs/21a05e27-1cb3-4e9b-9a17-4bf2532d5b1a/images/62f4028dddb44905106c688f7dc04fa7b62d57579b748e1e9e91c7fedc4c687e.jpeg', rating: 4.8, reviews: 39 },
  { id: 'il-natural-wave', texture: 'Natural Wave', image: 'https://static.prod-images.emergentagent.com/jobs/21a05e27-1cb3-4e9b-9a17-4bf2532d5b1a/images/4ecd05ff68debd206f2551d7b78d99cd410ed3c0bc28caadb9a50ee0aa969ea8.jpeg', rating: 4.9, reviews: 58 },
  { id: 'il-kinky-curly', texture: 'Kinky Curly', image: 'https://static.prod-images.emergentagent.com/jobs/21a05e27-1cb3-4e9b-9a17-4bf2532d5b1a/images/e11ae640111ddac63459f81bba3c6105086c14591215498faf6d31dd39c29d9c.jpeg', rating: 4.9, reviews: 66 },
];

const IMPERIAL_LUXE_PRODUCTS = IMPERIAL_LUXE_DATA.map((p, i) => ({
  id: p.id,
  name: `Imperial Luxe ${p.texture} Bundle`,
  category: 'bundles',
  collection: 'imperial-luxe',
  price: 120,
  rating: p.rating,
  reviews: p.reviews,
  bestseller: i === 0,
  image: p.image,
  gallery: [p.image],
  lengths: ['16"', '18"', '20"', '22"', '24"', '26"', '28"', '30"'],
  colors: ['Natural 1B'],
  description: IMPERIAL_LUXE_DESC,
  features: IMPERIAL_LUXE_FEATURES,
}));

export const PRODUCTS = [
  ...IMPERIAL_LUXE_PRODUCTS,
  {
    id: 'wig-straight-20-1b',
    name: '20\" Straight Glueless Wig \u2013 1B',
    category: 'wigs',
    collection: 'signature-reign',
    price: 150,
    rating: 4.9,
    reviews: 128,
    bestseller: true,
    image: wigStraightImg,
    gallery: [wigStraightImg, wigStraight1, wigStraight2, wigStraight3],
    lengths: ['20\"'],
    colors: ['Natural 1B'],
    description: 'Step into effortless elegance with our 20-inch Straight Glueless Wig, designed for women who want flawless beauty without the hassle. Made from 100% Virgin Brazilian Human Hair, this unit delivers unmatched softness, shine, and versatility that feels just like your natural hair. The 13x4 Transparent HD Lace Frontal provides a realistic, scalp-like appearance that blends seamlessly with any skin tone, while the glueless construction lets you install and remove the wig with ease. With 250% density, you enjoy a full-bodied, luxurious look that is voluminous yet lightweight \u2014 perfect for daily wear or glamorous occasions. The natural 1B (off-black) color adds a rich, classic finish that complements all complexions.',
    features: [
      'Length: 20 inches \u00b7 Texture: Straight',
      'Color: 1B (Natural Off-Black)',
      'Lace: Transparent HD Lace (13x4 Frontal)',
      'Density: 250% \u2013 Full & Thick',
      '100% Virgin Brazilian Human Hair',
      'Glueless cap with adjustable straps & combs',
      'Pre-plucked hairline with baby hairs',
      'Can be straightened, curled, dyed & washed',
    ],
    whyLove: [
      'Glueless & Beginner Friendly: Easy on, easy off \u2014 no adhesive or salon appointment needed.',
      'Natural Look & Feel: Transparent lace melts effortlessly for a flawless finish.',
      'Thick & Luxurious: 250% density gives you stunning volume without bulk.',
      'Versatile Styling: From sleek and straight to bouncy waves, it holds every look beautifully.',
      'Long-Lasting Quality: Virgin Brazilian hair ensures durability, softness, and minimal shedding.',
    ],
    perfectFor: 'Everyday wear, special events, photoshoots, or simply turning heads wherever you go. This wig combines beauty, convenience, and confidence \u2014 all in one premium design.',
  },
  {
    id: 'wig-bodywave-20-1b',
    name: 'Body Wave Glueless Wig 20\" \u2013 1B',
    category: 'wigs',
    collection: 'signature-reign',
    price: 150,
    rating: 4.8,
    reviews: 96,
    bestseller: true,
    image: wigBodywaveImg,
    gallery: [wigBodywaveImg, wigBodywave1, wigBodywave2],
    lengths: ['20\"'],
    colors: ['Natural 1B'],
    description: 'Turn heads with our 20-inch Body Wave Glueless Wig \u2014 crafted from 100% Virgin Brazilian Human Hair for irresistible bounce, movement, and shine. The 13x4 Transparent HD Lace Frontal melts seamlessly into any skin tone for a natural, scalp-like finish, while the glueless cap lets you install and remove it in minutes with no adhesive. At 250% density, this unit delivers full-bodied, voluminous waves that stay soft and lightweight all day. The natural 1B (off-black) color adds a rich, classic finish that flatters every complexion.',
    features: [
      'Length: 20 inches \u00b7 Texture: Body Wave',
      'Color: 1B (Natural Off-Black)',
      'Lace: Transparent HD Lace (13x4 Frontal)',
      'Density: 250% \u2013 Full & Thick',
      '100% Virgin Brazilian Human Hair',
      'Glueless cap with adjustable straps & combs',
      'Pre-plucked hairline with baby hairs',
      'Can be straightened, curled, dyed & washed',
    ],
    whyLove: [
      'Glueless & Beginner Friendly: Easy on, easy off \u2014 no adhesive or salon appointment needed.',
      'Natural Look & Feel: Transparent lace melts effortlessly for a flawless finish.',
      'Thick & Luxurious: 250% density gives you stunning volume without bulk.',
      'Effortless Waves: Soft, bouncy body wave texture that holds beautifully wash after wash.',
      'Long-Lasting Quality: Virgin Brazilian hair ensures durability, softness, and minimal shedding.',
    ],
    perfectFor: 'Everyday wear, special events, photoshoots, or simply turning heads wherever you go. This wig combines beauty, convenience, and confidence \u2014 all in one premium design.',
  },
  {
    id: 'braid-knotless-black',
    name: 'Sensationnel Braids X-Pression 4X Pre-Stretched Braid 38"',
    category: 'braiding-hair',
    price: 9.99,
    rating: 4.9,
    reviews: 210,
    bestseller: true,
    image: braidsImg,
    gallery: [braidsImg, xpr4a, xpr4b, xpr4c, xpr4d, xprLight, xprBanner, xprPink],
    lengths: ['38\"'],
    colors: ['1B Off Black'],
    description: '4X multi-pack item with pre-stretched X-Pression braiding hair \u2014 a total of 4 bundles in one pack.',
    features: [
      '100% Kanekalon\u00ae',
      'Flame Retardant Fiber',
      'Light & Soft Touch',
      'Pre-stretched to save on prep time',
      'Pre-layered for a natural, finished style',
      'Hot water set',
    ],
  },
  {
    id: 'braid-honey',
    name: '3-Pack Sensationnel X-Pression Pre-Stretched Braid 58"',
    category: 'braiding-hair',
    price: 9.99,
    rating: 4.8,
    reviews: 88,
    image: braidXpr1,
    gallery: [braidXpr1, xprLight, xprBanner, xprPink],
    lengths: ['58\"'],
    colors: ['1B Off Black'],
    description: 'Achieve long, flawless braids with Sensationnel X-Pression Pre-Stretched Braid. This ultra-light, tangle-free hair is pre-stretched for faster braiding and a natural, professional finish. Perfect for box braids, twists, and other protective styles.',
    features: [
      '3X Pack \u2013 More hair for full, voluminous styles',
      'Pre-Stretched Design \u2013 Saves time and reduces tangles',
      'Lightweight & Soft \u2013 Comfortable for extended wear',
      'Hot Water Set Friendly \u2013 Seal ends for long-lasting hold',
      'Length \u2013 58 inches for extra-long styling options',
    ],
  },
  {
    id: 'braid-caramel',
    name: 'Sensationnel X-Pressions Pre-Stretched Braid 58" 6X Pack',
    category: 'braiding-hair',
    price: 12.99,
    rating: 4.7,
    reviews: 63,
    image: braid6xMain,
    gallery: [braid6xMain, braidXpr2, xpr6pack, xprLight, xprBanner, xprPink],
    lengths: ['58\"'],
    colors: ['1B Off Black'],
    description: 'Achieve long, flawless braids with Sensationnel X-Pression Pre-Stretched Braid. This ultra-light, tangle-free hair is pre-stretched for faster braiding and a natural, professional finish. Perfect for box braids, twists, and other protective styles.',
    features: [
      '6X Pack \u2013 More hair for full, voluminous styles',
      'Pre-Stretched Design \u2013 Saves time and reduces tangles',
      'Lightweight & Soft \u2013 Comfortable for extended wear',
      'Hot Water Set Friendly \u2013 Seal ends for long-lasting hold',
      'Length \u2013 58 inches for extra-long styling options',
    ],
  },
  {
    id: 'bundle-raw-straight',
    name: 'Raw Straight Bundle \u2013 Single',
    category: 'bundles',
    collection: 'silk-dynasty',
    price: 95,
    rating: 5.0,
    reviews: 142,
    bestseller: true,
    image: bundleRawImg,
    gallery: [bundleRawImg],
    lengths: ['16\"', '18\"', '20\"', '22\"', '24\"', '26\"'],
    colors: ['Natural 1B'],
    description: 'Ethically sourced raw straight hair, single-donor and cuticle aligned. Colors and styles beautifully, lasts for years.',
  },
  {
    id: 'bundle-bodywave',
    name: 'Virgin Body Wave Bundle',
    category: 'bundles',
    collection: 'silk-dynasty',
    price: 89,
    rating: 4.9,
    reviews: 117,
    image: 'https://images.unsplash.com/photo-1745975980824-bc88bd400c78',
    gallery: ['https://images.unsplash.com/photo-1745975980824-bc88bd400c78'],
    lengths: ['18\"', '20\"', '22\"', '24\"'],
    colors: ['Natural 1B'],
    description: 'Full, double-drawn virgin body wave wefts. Thick from root to tip with minimal shedding for a flawless sew-in.',
  },
  {
    id: 'bundle-deep-blonde',
    name: 'Blonde Deep Wave Bundle',
    category: 'bundles',
    collection: 'silk-dynasty',
    price: 110,
    rating: 4.8,
    reviews: 45,
    image: 'https://images.unsplash.com/photo-1554519934-e32b1629d9ee',
    gallery: ['https://images.unsplash.com/photo-1554519934-e32b1629d9ee'],
    lengths: ['20\"', '22\"', '24\"'],
    colors: ['#613 Blonde', 'Natural 1B'],
    description: 'Pre-lightened deep wave wefts ready to tone. Voluminous curls with incredible movement and shine.',
  },
  {
    id: 'bundle-silk-dynasty',
    name: 'Silk Dynasty Virgin Hair Bundle',
    category: 'bundles',
    collection: 'silk-dynasty',
    price: 99,
    rating: 4.9,
    reviews: 68,
    bestseller: true,
    image: silkDynastyProduct,
    gallery: [silkDynastyProduct],
    lengths: ['16\"', '18\"', '20\"', '22\"', '24\"', '26\"'],
    colors: ['Natural 1B'],
    description: 'Minimally processed virgin hair with natural luster and movement. Soft, lightweight and beginner-friendly \u2013 everyday luxury at an affordable price. Available in Straight, Body Wave, Loose Deep, Deep Wave, Water Wave, Loose Wave, Natural Wave and Kinky Curly.',
  },
  {
    id: 'frontal-hd-13x4',
    name: '13x4 HD Lace Frontal',
    category: 'frontals',
    price: 55,
    rating: 4.9,
    reviews: 89,
    bestseller: true,
    image: frontalImg,
    gallery: [frontalImg],
    lengths: ['16\"', '18\"', '20\"', '22\"'],
    colors: ['Natural 1B', 'Transparent Lace'],
    description: 'Ultra-thin HD lace that melts seamlessly into every skin tone. Pre-plucked hairline with natural density for an undetectable install.',
  },
  {
    id: 'closure-5x5',
    name: '5x5 HD Lace Closure',
    category: 'frontals',
    price: 42,
    rating: 4.8,
    reviews: 61,
    image: 'https://images.unsplash.com/photo-1628682814595-a3f0816b25ff',
    gallery: ['https://images.unsplash.com/photo-1628682814595-a3f0816b25ff'],
    lengths: ['14\"', '16\"', '18\"', '20\"'],
    colors: ['Natural 1B'],
    description: 'Versatile 5x5 closure for a natural middle or side part. Bleached knots and baby hairs for a flawless, realistic finish.',
  },
  {
    id: 'acc-satin-bonnet',
    name: 'Silk-Lined Satin Bonnet',
    category: 'accessories',
    price: 18,
    rating: 4.9,
    reviews: 203,
    bestseller: true,
    image: 'https://images.pexels.com/photos/7897135/pexels-photo-7897135.jpeg',
    gallery: ['https://images.pexels.com/photos/7897135/pexels-photo-7897135.jpeg'],
    lengths: [],
    colors: ['Champagne', 'Black', 'Blush'],
    description: 'Double-lined pure satin bonnet that protects your style overnight, reduces frizz and locks in moisture. Adjustable elastic band for all-night comfort.',
  },
  {
    id: 'acc-satin-set',
    name: 'Satin Scrunchie & Wrap Set',
    category: 'accessories',
    price: 16,
    rating: 4.7,
    reviews: 77,
    image: 'https://images.pexels.com/photos/7897137/pexels-photo-7897137.jpeg',
    gallery: ['https://images.pexels.com/photos/7897137/pexels-photo-7897137.jpeg'],
    lengths: [],
    colors: ['Mint', 'Champagne'],
    description: 'Gentle satin scrunchies and a matching hair wrap that protect edges and prevent breakage. Kind to every texture.',
  },
  {
    id: 'acc-gold-clip',
    name: 'Gold Finishing Clip Set',
    category: 'accessories',
    price: 22,
    rating: 4.8,
    reviews: 54,
    image: 'https://images.unsplash.com/photo-1744177762258-c98418b7a4eb',
    gallery: ['https://images.unsplash.com/photo-1744177762258-c98418b7a4eb'],
    lengths: [],
    colors: ['Gold'],
    description: 'Elegant gold-tone hair clips to elevate any style. Strong hold with a luxe finish \u2014 the perfect final touch.',
  },
];

export const TESTIMONIALS = [
  { name: 'Aaliyah M.', location: 'Atlanta, GA', text: 'The glueless unit is unreal \u2014 the hairline looks like it grew out of my scalp. I get compliments every single day.', rating: 5 },
  { name: 'Simone T.', location: 'Cincinnati, OH', text: 'Nikki\u2019s braiding hair is the only one that doesn\u2019t itch me. Feather light and lasted my whole vacation.', rating: 5 },
  { name: 'Destiny R.', location: 'Chicago, IL', text: 'These raw bundles have lasted me almost two years. Worth every penny. Truly next level quality.', rating: 5 },
  { name: 'Jasmine W.', location: 'Houston, TX', text: 'The HD frontal melted so perfectly no one believes it\u2019s a wig. This is my go-to shop now.', rating: 5 },
  { name: 'Camille B.', location: 'Detroit, MI', text: 'Fast shipping, gorgeous packaging, and the hair is so soft. Nikki\u2019s exceeded every expectation.', rating: 5 },
  { name: 'Nia J.', location: 'Brooklyn, NY', text: 'I\u2019ve ordered five times now. The consistency and quality never miss. My clients love it too.', rating: 5 },
  { name: 'Kayla D.', location: 'Los Angeles, CA', text: 'Brooke\u2019s consultation matched me with the perfect texture on the first try. Service this personal is rare.', rating: 5 },
];

export const HERO_IMAGES = {
  main: 'https://images.unsplash.com/photo-1527203561188-dae1bc1a417f',
  wrap: 'https://images.unsplash.com/photo-1613876215075-276fd62c89a4',
  crown: 'https://images.unsplash.com/photo-1612659513025-fe37f67574d6',
  sleek: 'https://images.unsplash.com/photo-1628682814595-a3f0816b25ff',
};

export const getProductById = (id) => PRODUCTS.find((p) => p.id === id);
export const getProductsByCategory = (slug) =>
  slug === 'all' ? PRODUCTS : PRODUCTS.filter((p) => p.category === slug);

// Queen's Choice Collection (Wigs) \u2013 placeholder products (coming soon)
export const QUEENS_CHOICE = [
  { id: 'qc-straight', texture: 'Straight' },
  { id: 'qc-body-wave', texture: 'Body Wave' },
  { id: 'qc-loose-deep', texture: 'Loose Deep' },
  { id: 'qc-deep-wave', texture: 'Deep Wave' },
  { id: 'qc-kinky-curly', texture: 'Kinky Curly' },
  { id: 'qc-natural-wave', texture: 'Natural Wave' },
];

// Imperial Luxe Collection (Bundles) \u2013 placeholder products (coming soon)
// Silk Dynasty Collection uses the SAME 8 placeholders.
export const IMPERIAL_LUXE = [
  { id: 'il-straight', texture: 'Straight' },
  { id: 'il-body-wave', texture: 'Body Wave' },
  { id: 'il-loose-deep', texture: 'Loose Deep' },
  { id: 'il-deep-wave', texture: 'Deep Wave' },
  { id: 'il-water-wave', texture: 'Water Wave' },
  { id: 'il-loose-wave', texture: 'Loose Wave' },
  { id: 'il-natural-wave', texture: 'Natural Wave' },
  { id: 'il-kinky-curly', texture: 'Kinky Curly' },
];

// Silk Dynasty Collection (Bundles) \u2013 same 8 placeholders as Imperial Luxe
export const SILK_DYNASTY = IMPERIAL_LUXE.map((p) => ({ ...p, id: p.id.replace('il-', 'sd-') }));

const _FRONTAL_REVIEW_A = 'https://static.prod-images.emergentagent.com/jobs/21a05e27-1cb3-4e9b-9a17-4bf2532d5b1a/images/8a90d99e90abaa3ce4ff169c0a49d889cae4a15526632edea5c04ff60613b8b8.jpeg';
const _FRONTAL_REVIEW_B = 'https://static.prod-images.emergentagent.com/jobs/21a05e27-1cb3-4e9b-9a17-4bf2532d5b1a/images/8434bbd2b9b63d8985bda12b89acd8d2aa6a874371915b6d53aaa3bfe16a4b3b.jpeg';

// Customer photo reviews, grouped by category
export const PRODUCT_TESTIMONIALS = {
  wigs: [
    { name: 'Aaliyah M.', location: 'Atlanta, GA', rating: 5, text: 'The glueless unit is unreal — the hairline looks like it grew out of my scalp.', image: tlook1 },
    { name: 'Camille B.', location: 'Detroit, MI', rating: 5, text: 'So soft and full. I installed it in ten minutes and wore it straight to brunch.', image: tlook2 },
    { name: 'Nia J.', location: 'Brooklyn, NY', rating: 5, text: 'My go-to unit now. The density is everything and it never sheds.', image: tlook3 },
    { name: 'Robin P.', location: 'Dallas, TX', rating: 5, text: 'Bounciest body wave I have ever owned. Compliments all day, every day.', image: tlook4 },
  ],
  bundles: [
    { name: 'Destiny R.', location: 'Chicago, IL', rating: 5, text: 'These raw bundles have lasted me almost two years. Worth every penny.', image: tlook6 },
    { name: 'Imani S.', location: 'Memphis, TN', rating: 5, text: 'Silk Dynasty is thick from root to tip. My sew-in looks like a frontal.', image: tlook7 },
    { name: 'Zoe A.', location: 'Oakland, CA', rating: 5, text: 'Imperial Luxe is the softest hair I have touched. Zero tangling.', image: tlook1 },
    { name: 'Maya H.', location: 'Newark, NJ', rating: 5, text: 'Dyed them to 27 and they took the color beautifully. Obsessed.', image: tlook3 },
  ],
  'braiding-hair': [
    { name: 'Simone T.', location: 'Cincinnati, OH', rating: 5, text: 'The only braiding hair that does not itch me. Feather light for weeks.', image: tbraid1 },
    { name: 'Tiana L.', location: 'Baltimore, MD', rating: 5, text: 'Pre-stretched saved me hours. The 6X pack did my whole head with extra.', image: tbraid3 },
    { name: 'Brianna K.', location: 'Charlotte, NC', rating: 5, text: 'Hot-water sealed and the ends stayed crisp my entire vacation.', image: tbraid5 },
    { name: 'Aaliyah M.', location: 'Atlanta, GA', rating: 5, text: 'My box braids came out so full and glossy — compliments for a whole month.', image: 'https://images.unsplash.com/photo-1539702169544-c0bcff87fcd7?crop=entropy&cs=srgb&fm=jpg&q=85&w=800' },
    { name: 'Nia P.', location: 'Detroit, MI', rating: 5, text: 'Neat and lightweight from day one. My scalp never felt sore or heavy.', image: 'https://images.unsplash.com/photo-1592520113018-180c8bc831c9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800' },
    { name: 'Camille R.', location: 'Dallas, TX', rating: 5, text: 'Perfect for my goddess braids — soft, bouncy, and zero frizz all season.', image: 'https://images.unsplash.com/photo-1613099084406-4b9140fc780a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800' },
    { name: 'Jada W.', location: 'Brooklyn, NY', rating: 5, text: 'Jumbo braids all the way down my back and still feather-light. Obsessed.', image: 'https://images.unsplash.com/photo-1613730317928-246094cb6a82?crop=entropy&cs=srgb&fm=jpg&q=85&w=800' },
  ],
  frontals: [
    { name: 'Jasmine W.', location: 'Houston, TX', rating: 5, text: 'The HD frontal melted so perfectly no one believes it is a wig.', image: _FRONTAL_REVIEW_A },
    { name: 'Alicia D.', location: 'Miami, FL', rating: 5, text: 'The 13x6 parting space is unreal — I can style it any direction.', image: _FRONTAL_REVIEW_B },
    { name: 'Kennedy R.', location: 'St. Louis, MO', rating: 5, text: 'Bleached the knots and it disappeared into my skin. Flawless install.', image: _FRONTAL_REVIEW_A },
    { name: 'Sydney M.', location: 'Columbus, OH', rating: 5, text: 'My 5x5 closure looks like a scalp. Beginner friendly and gorgeous.', image: _FRONTAL_REVIEW_B },
  ],
  accessories: [
    { name: 'Kayla D.', location: 'Los Angeles, CA', rating: 5, text: 'My consultation with Brooke was worth every minute — she knew exactly which bundle texture would blend with my natural hair.', image: tlook2 },
    { name: 'Erica N.', location: 'Phoenix, AZ', rating: 5, text: 'The Silk Dynasty bundles I ordered are thick from root to tip. Whatever drops here next, I already know the quality will match.', image: tlook4 },
    { name: 'Whitney F.', location: 'Seattle, WA', rating: 5, text: 'Everything ships fast and the packaging feels like a gift. The service at Nikki\'s Next Level keeps me coming back.', image: tlook6 },
    { name: 'Paige C.', location: 'Denver, CO', rating: 5, text: 'Brooke answered every question about my HD frontal the same day. She truly knows her products inside out.', image: tlook7 },
  ],
};

// Shown on any Coming Soon product page — only about available products, service, or Brooke consultations
export const COMING_SOON_TESTIMONIALS = [
  { name: 'Ayana T.', location: 'Atlanta, GA', rating: 5, text: 'I booked a consultation with Brooke before buying my first unit — she asked about my lifestyle and matched me with the 20" Straight Glueless Wig. Flawless call.' },
  { name: 'Monique H.', location: 'Houston, TX', rating: 5, text: 'While I wait for this drop, my Imperial Luxe bundles are still silky after months of installs. If this piece is anything like them, it will sell out.' },
  { name: 'Crystal J.', location: 'Chicago, IL', rating: 5, text: 'Fast shipping, luxury packaging, and a follow-up email to make sure I was happy. Nikki\'s Next Level service is genuinely next level.' },
  { name: 'Deja R.', location: 'Detroit, MI', rating: 5, text: 'Brooke spent twenty minutes on the phone helping me choose between a closure and a frontal. Her knowledge alone earned a customer for life.' },
  { name: 'Tierra S.', location: 'Memphis, TN', rating: 5, text: 'The braiding hair I ordered was itch-free and feather light for weeks. I trust anything this shop releases next.' },
  { name: 'Simone V.', location: 'Brooklyn, NY', rating: 5, text: 'I had an issue with my address and customer service fixed it within the hour — Brooke personally confirmed my order shipped. Unmatched care.' },
];

// Per-product reviews for frontal & closure pages (text-only)
export const PRODUCT_ID_TESTIMONIALS = {
  'closure-2x6': [
    { name: 'Jasmine W.', location: 'Houston, TX', rating: 5, text: 'The 2x6 deep part gives me that perfect sleek middle part every single time. It melts like scalp.' },
    { name: 'Renee C.', location: 'Atlanta, GA', rating: 5, text: 'I was torn between a 2x6 and a 4x4 — Brooke explained exactly why the deep part would suit my sleek styles. She was so right.' },
    { name: 'Kennedy R.', location: 'St. Louis, MO', rating: 5, text: 'Ordered on Monday, installed by Friday. Fast shipping and the lace was pre-plucked beautifully.' },
    { name: 'Tamia S.', location: 'Charlotte, NC', rating: 5, text: 'The deep parting space on this 2x6 is unreal — my braid-down stays flat and the part looks natural for weeks.' },
    { name: 'Alexis B.', location: 'Chicago, IL', rating: 5, text: 'Customer service is top tier. Brooke answered all my lace questions the same day and helped me pick my density.' },
  ],
  'closure-4x4': [
    { name: 'Sydney M.', location: 'Columbus, OH', rating: 5, text: 'My 4x4 closure looks like a scalp. Beginner friendly and gorgeous — my first ever self-install came out flawless.' },
    { name: 'Morgan T.', location: 'Dallas, TX', rating: 5, text: 'Brooke really knows her lace. She told me a 4x4 was perfect for my everyday middle part and saved me from over-buying.' },
    { name: 'Chloe D.', location: 'Memphis, TN', rating: 5, text: 'HD lace disappeared into my skin with barely any tinting. Best 4x4 I have owned.' },
    { name: 'Ari J.', location: 'Brooklyn, NY', rating: 5, text: 'Shipping was quick and the packaging felt like a luxury gift. Will absolutely reorder.' },
    { name: 'Bianca L.', location: 'Oakland, CA', rating: 5, text: 'The knots bleached in minutes and the closure held its shape wash after wash. Great quality for the price.' },
  ],
  'closure-5x5': [
    { name: 'Taylor N.', location: 'Miami, FL', rating: 5, text: 'The 5x5 gives me just enough extra parting room to switch from middle to side part. Melted flat with no plucking needed.' },
    { name: 'Dominique F.', location: 'Detroit, MI', rating: 5, text: 'I asked Brooke whether to size up from my 4x4 and she broke down the 5x5 coverage perfectly. So knowledgeable about her closures.' },
    { name: 'Raven K.', location: 'Newark, NJ', rating: 5, text: 'This HD lace is the thinnest I have used — it literally looks like my scalp is growing the hair.' },
    { name: 'Skye P.', location: 'Phoenix, AZ', rating: 5, text: 'Fast delivery, careful packaging, and a follow-up email to make sure I was happy. Service is unmatched.' },
    { name: 'Janae H.', location: 'Baltimore, MD', rating: 5, text: 'Three months in and my 5x5 still lays flat after every re-install. Zero shedding at the lace.' },
  ],
  'closure-6x6': [
    { name: 'Amber G.', location: 'Cincinnati, OH', rating: 5, text: 'The 6x6 coverage lets me pull my edges into a half-up style without exposing any tracks. Total game changer.' },
    { name: 'Danielle V.', location: 'Seattle, WA', rating: 5, text: 'Brooke walked me through why a 6x6 beats a frontal for my fine edges — she clearly knows every piece she sells.' },
    { name: 'Leah W.', location: 'Denver, CO', rating: 5, text: 'The lace tinted to my complexion perfectly and the parting space is huge. Best closure purchase this year.' },
    { name: 'Kiara M.', location: 'Houston, TX', rating: 5, text: 'Ordered late Thursday night and it still shipped the next morning. The service here is genuinely excellent.' },
    { name: 'Toni R.', location: 'Atlanta, GA', rating: 5, text: 'My stylist asked where I got this 6x6 because the knots were already so clean. Restocking for my next install.' },
  ],
  'closure-7x7': [
    { name: 'Essence B.', location: 'Chicago, IL', rating: 5, text: 'The 7x7 is basically frontal coverage without the frontal maintenance. I can part it anywhere and it looks like scalp.' },
    { name: 'Nadia C.', location: 'Brooklyn, NY', rating: 5, text: 'I had never heard of a 7x7 until Brooke explained the coverage options — her product knowledge sold me and she was 100% right.' },
    { name: 'Paris E.', location: 'Memphis, TN', rating: 5, text: 'Deep side part, middle part, even a slick-back — this 7x7 handles all of it beautifully.' },
    { name: 'Jordan A.', location: 'Dallas, TX', rating: 5, text: 'Quick shipping, beautiful packaging, and a real person answering my questions. That is why I keep coming back.' },
    { name: 'Milan S.', location: 'Detroit, MI', rating: 5, text: 'The HD lace on this 7x7 is feather thin and the density is perfect from root to tip.' },
  ],
  'frontal-13x4': [
    { name: 'Jasmine W.', location: 'Houston, TX', rating: 5, text: 'The HD 13x4 melted so perfectly no one believes it is not my hairline. Ear-to-ear flawless.' },
    { name: 'Brielle T.', location: 'Miami, FL', rating: 5, text: 'Brooke helped me choose between the 13x4 and 13x6 based on how I style my baby hairs. Her advice was spot on.' },
    { name: 'Kayla J.', location: 'Columbus, OH', rating: 5, text: 'Bleached the knots, tinted the lace, and it disappeared into my skin. The pre-plucked hairline saved me so much time.' },
    { name: 'Autumn D.', location: 'Oakland, CA', rating: 5, text: 'Arrived two days early with a handwritten thank-you note. The service feels personal every time.' },
    { name: 'Cherish L.', location: 'Newark, NJ', rating: 5, text: 'This 13x4 held a deep side part and a sleek ponytail in the same week. The lace is so strong yet invisible.' },
  ],
  'frontal-13x6': [
    { name: 'Alicia D.', location: 'Miami, FL', rating: 5, text: 'The 13x6 parting space is unreal — I can style it in any direction and the deep part always looks like scalp.' },
    { name: 'Yara M.', location: 'Atlanta, GA', rating: 5, text: 'I asked Brooke a dozen questions about the 13x6 lace and she knew every answer instantly. You can tell she truly knows her hair.' },
    { name: 'Sasha P.', location: 'Chicago, IL', rating: 5, text: 'Six inches of parting space means my deep side part finally looks natural. Best frontal I have ever installed.' },
    { name: 'Harmony F.', location: 'St. Louis, MO', rating: 5, text: 'Great communication, fast shipping, and they checked in after delivery. Five-star service from start to finish.' },
    { name: 'Diamond K.', location: 'Baltimore, MD', rating: 5, text: 'The HD lace on this 13x6 is thinner than any frontal I have tried and it survived a full month of styling.' },
  ],
};

export const getTestimonials = (category, productId, comingSoon) => {
  if (comingSoon) return COMING_SOON_TESTIMONIALS;
  if (productId && PRODUCT_ID_TESTIMONIALS[productId]) return PRODUCT_ID_TESTIMONIALS[productId];
  if (category && PRODUCT_TESTIMONIALS[category]) return PRODUCT_TESTIMONIALS[category];
  // mixed set (one from each category)
  return Object.values(PRODUCT_TESTIMONIALS).map((arr) => arr[0]);
};
